import { getApplicationState } from '@/app/Application.slice.ts';
import { useAppSelector } from '@/app/hooks.ts';
import { CheckAuth } from '@/features/login/CheckAuth.tsx';
import { ReactNode } from 'react';

/**
 * Wrapper component to enforce authentication
 *
 * if the user is not logged but a token is present in URL, we try to login with it
 *
 * @param props          Props
 * @param props.redirect where to redirect if not logged
 * @param props.graceful if true, will not display the session expired alert
 * @param props.children the children to render if logged
 *
 * @returns              RequireAuth component
 */
export const RequireAuth = ({
  redirect = '/login',
  graceful = false,
  children,
}: {
  redirect?: string;
  graceful?: boolean;
  children: ReactNode | ReactNode[];
}) => {
  const { isLogged } = useAppSelector(getApplicationState);

  // if everything's good, return the children
  if (isLogged) {
    return <>{children}</>;
  }

  // not logged and no token, redirect to login or provided url
  return (
    <CheckAuth
      redirect={redirect}
      graceful={graceful}
    >
      {children}
    </CheckAuth>
  );
};
